import { Chat as ApiChat, Message as ApiMessage } from '../apis/types';
import { Message, Chat } from '../types';

// Helper function to transform API messages to UI format
export const transformApiMessageToUI = (apiMessage: ApiMessage): Message => {
  return {
    id: apiMessage.id,
    text: apiMessage.text,
    sender: apiMessage.sender, // Use the actual sender name from backend
    timestamp: apiMessage.createdAt || new Date().toISOString(), // Fallback to current time if createdAt is missing
    attachmentFileName: apiMessage.attachment?.storageKey
      ? getFileNameFromStorageKey(apiMessage.attachment.storageKey)
      : undefined,
    attachmentStorageKey: apiMessage.attachment?.storageKey,
    receiptId: apiMessage.receiptId,
    bookingGenerationJobId: apiMessage.bookingGenerationJobId,
  };
};

// Helper function to extract filename from storage key
export const getFileNameFromStorageKey = (storageKey: string): string => {
  const parts = storageKey.split('/');
  const lastPart = parts[parts.length - 1];
  // Remove UUID prefix if present (e.g., "3c7a417a-3684-4c6d-9e89-015ab524e89d_hapham_test_invoice.pdf")
  const match = lastPart.match(/^[a-f0-9-]+_(.+)$/);
  return match ? match[1] : lastPart;
};

// Helper function to transform API chats to UI format
export const transformApiChatToUI = (apiChat: ApiChat): Chat => ({
  id: apiChat.id,
  title: apiChat.title,
  starred: apiChat.starred,
  updatedAt: apiChat.updatedAt,
  messages: [], // Messages will be loaded separately
});
